import { render, staticRenderFns } from "./BillingAndPaymentComponent.vue?vue&type=template&id=392a16b5&"
import script from "./BillingAndPaymentComponent.vue?vue&type=script&lang=js&"
export * from "./BillingAndPaymentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports